import { registerSchema } from "yage/components/ComponentRegistry";
import { Component, Schema } from "yage/decorators/type";

@Component("BossType")
export class BossTypeSchema extends Schema {}

registerSchema(BossTypeSchema);
